<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TYdJ8q/cover.jpeg?1684229398169" alt="This image is the cover for the book Peerless Ghost Doctor, Volume 10"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peerless Ghost Doctor, Volume 10
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Li Su's life was very exciting. Last month, he married his thirteenth beautiful wife, a young international model, in the United States. Last week, he bought a fifteenth private island in the South Pacific and planned to make a golf course.</strong></p><p>A few days ago, he even rejected the investment invitation of the Roschell family. Hm, he looked down on that small amount of money!</p><p>He's a genius, he's a legend!</p><p>At the age of 20, he had millions of properties and at the age of 23, he was evaluated as the youngest rich man in Asia. His life was filled with glory and glory.</p><p>Of course, he also had a weakness of wanting to boast to the best of his ability, and that was that even at the end of his life, he still hadn't changed his habit of bragging.</p><p>Yes, it was all bragging.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yu Gu, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c4f28f20